import { Button, Responses403, Responses404, Responses500 } from 'uikit';
import { ERROR_403_PATH, ERROR_500_PATH } from 'utils/constants';

import { useCallback, useMemo } from 'react';
import type { Location } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';

import Styles from './AccessDeniedPage.module.css';

const getComponent = (actions: JSX.Element, location: Location) => {
    if (location.pathname === ERROR_500_PATH) {
        return <Responses500 size="m" actions={actions} />;
    }

    if (location.pathname === ERROR_403_PATH) {
        return <Responses403 size="m" actions={actions} description=" " />;
    }

    return <Responses404 size="m" actions={actions} />;
};

export const AccessDeniedPage = (): any => {
    const navigate = useNavigate();
    const location = useLocation();

    const goBackHandler = useCallback(
        (destination) => () => {
            navigate(destination);
        },
        [navigate],
    );

    const actions = useMemo(
        () => (
            <div className={Styles.actionsBlock}>
                <Button
                    view="secondary"
                    label="Перейти в реестр проектов"
                    onClick={goBackHandler('/')}
                    className={Styles.goToRegistryBtn}
                />
                <Button view="clear" label="Вернуться назад" onClick={goBackHandler(-1)} size="xs" />
            </div>
        ),

        [goBackHandler],
    );

    return <div className={Styles.container}>{getComponent(actions, location)}</div>;
};

AccessDeniedPage.displayName = 'AccessDeniedPage';
